import template from './has-water.jade';

export default angular
    .module('cian.addForm.hasWater', [])
    .directive('cianAfAboutObjectHasWater', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = [{
                text: 'Есть',
                value: true,
            }, {
                text: 'Нет',
                value: false,
            }];
        },
        controllerAs: 'hasWater',
        template,
    }))
    .name;
